var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEditTooltip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.44C0 4.16204 0 3.02306 0.450346 2.1561C0.829848 1.42553 1.42553 0.829848 2.1561 0.450346C3.02306 0 4.16204 0 6.44 0H13.56C15.838 0 16.9769 0 17.8439 0.450346C18.5745 0.829848 19.1702 1.42553 19.5497 2.1561C20 3.02306 20 4.16204 20 6.44V13.56C20 15.838 20 16.9769 19.5497 17.8439C19.1702 18.5745 18.5745 19.1702 17.8439 19.5497C16.9769 20 15.838 20 13.56 20H6.44C4.16204 20 3.02306 20 2.1561 19.5497C1.42553 19.1702 0.829848 18.5745 0.450346 17.8439C0 16.9769 0 15.838 0 13.56V6.44Z",
    fill: "#E8EAF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68308 5.57812H7.91902C6.46823 5.57812 5.55859 6.60357 5.55859 8.05531V11.9715C5.55859 13.4232 6.46398 14.4487 7.91902 14.4487H12.0822C13.5377 14.4487 14.4431 13.4232 14.4431 11.9715V10.0742",
    stroke: "#737FA4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42597 9.4072L11.9517 5.88714C12.391 5.44908 13.1029 5.44908 13.5422 5.88714L14.1164 6.46039C14.5556 6.89893 14.5556 7.61019 14.1164 8.04826L10.5736 11.5853C10.3816 11.777 10.1212 11.8849 9.8494 11.8849H8.08203L8.12638 10.1043C8.13299 9.84244 8.24008 9.59279 8.42597 9.4072Z",
    stroke: "#737FA4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4141 6.42969L13.5683 8.58044",
    stroke: "#737FA4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditTooltip);
export default __webpack_public_path__ + "static/media/icon-edit-tooltip.275132a1.svg";
export { ForwardRef as ReactComponent };